import { Injectable } from '@angular/core';
import { NavigatorService } from '../../services/navigator/navigator.service';
import { ContactscreenCoreService } from 'src/app/@root-redux/contactscreen/services/contactscreen.service';
import { first, forkJoin } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FaqsDataLayer {
  private main_element: string | undefined;
  private cda_audience: string | undefined;
  private faq_owner: string | undefined;
  private event: string | undefined;
  private sub_elements: Array<any> | undefined;
  private cda_source!: string;
  private cda_userId!: string;
  private cda_journey!: string;
  private faq_id!: string;

  constructor(
    private navigatorService: NavigatorService,
    private contactscreenCoreService: ContactscreenCoreService,
  ) {}

  public setData = (
    mainElementName: string,
    audiences: Array<string> | null,
    faqOwner: string = '',
    faq_id: string = '',
  ): void => {
    this.faq_id = faq_id;
    this.main_element = mainElementName;
    this.cda_audience = this.renameAudience(audiences);
    this.faq_owner = faqOwner;
    this.event = 'send_data';
    this.sub_elements = [];
    this.cda_source = this.navigatorService.isApp ? 'App' : 'Web';
    forkJoin([
      this.contactscreenCoreService.getGlobalId().pipe(first()),
      this.contactscreenCoreService.getCdaJourney().pipe(first()),
    ]).subscribe(([globalId, cdaJourney]) => {
      this.cda_userId = globalId;
      this.cda_journey = cdaJourney;
    });
  };

  public saveData = (window: any): void => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(this);
  };

  public setSubElement = (
    subElementName: string,
    audiences: Array<string> | null,
    _faqOwner: string = '',
  ): void => {
    this.sub_elements?.push({
      name: subElementName,
      cda_audience: this.renameAudience(audiences),
      faq_owner: _faqOwner,
    });
  };

  private renameAudience = (audiences: Array<string> | null): string =>
    !audiences || audiences.length > 1 ? 'Todos los usuarios' : audiences[0];
}
